import React from "react";
import RfLogo from "../../Assets/Images/logoSmall.svg";
import { useNavigate } from "react-router-dom";
import { Button } from "Components/ui/button";

function NotFound({ all }) {
  const navigate = useNavigate();
  return (
    <div
      className={
        all
          ? "flex flex-col items-center w-[100vw] h-[100vh] justify-center"
          : "flex flex-col items-center w-full h-full justify-center"
      }
    >
      <div className="flex items-center w-full justify-center ">
        <div className="text-4xl font-N_Medium">Page Not Found!</div>
      </div>
      <Button className="w-[200px] mt-4" onClick={() => navigate("/")}>
        Go Home!
      </Button>
    </div>
  );
}

export default NotFound;
